import {
    Component, Input, OnInit
} from '@angular/core';
import { HttpService } from '../../services/http.service';
import { getWindow } from 'ssr-window';
import { HttpErrorResponse } from '@angular/common/http';
import { CfAlertService } from '@crediblefinance/credible-ui';
import { Router } from '@angular/router';
import { OnboardingService } from '../onboarding.service';
import AirdropTask from '../../models/AirdropTask';

@Component({
    selector: 'app-airdrop-share-on-twitter',
    templateUrl: './airdrop-share-on-twitter.component.html',
    styleUrls: [ './airdrop-share-on-twitter.component.scss' ]
})
export class AirdropShareOnTwitterComponent implements OnInit {
    @Input() task = new AirdropTask();

    constructor(public httpService: HttpService,
        private cfAlertService: CfAlertService,
        private router: Router,
        private onboardingService: OnboardingService
    ) {
        this.window = getWindow();
    }

    window: Window;
    invitation_link: string = '';

    public twitter: any = {
        loading: false,
        accountConnected: false
    };

    share_twitter_join_loading: boolean = false;

    ngOnInit(): void {
        this.attachSocketEvents();

        this.invitation_link = `${this.window.location.origin}/invite/${this.httpService.user.referral_code}`;
    }

    attachSocketEvents() {
        
    }

    login() {
        this.httpService.redirectUrl(this.constructor.name, '/login', {
            queryParams: {
                returnUrl: this.router.url
            }
        });
    }
    
    shareInvitationLinkOnTwitter() {
        this.share_twitter_join_loading = true;

        const text = 'Join Credible Finance with my invitation link';
        const hashtags = [
            'credible', 'finance', 'crediblefinance', 'solana', 'plume', 'ethereum'
        ].join(',');
        const via = 'crediblefin';

        const data = {
            via: via,
            hashtags: hashtags,
            text: text,
            url: this.invitation_link
        };

        const queryString = new URLSearchParams(data).toString();

        const url = `https://twitter.com/intent/tweet?${queryString}`;

        this.window.open(url, '_blank');

        this.onboardingService.shareInvitationLinkOnTwitter().subscribe((res: any) => {
            this.share_twitter_join_loading = false;

            if (this.httpService.user.twitter)
                this.httpService.user.twitter.share_on_twitter = true;
        }, (err: HttpErrorResponse) => {
            this.share_twitter_join_loading = false;

            console.error(err);

            this.cfAlertService.showError(err);
        });
    }
}
